export default "__VITE_ASSET__em5TA0KW__"